import { Box, Divider, Title } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

import { ColorsFormInput } from "common/admin/forms/ColorsFormInput";
import type { Quiz } from "quiz/types/quiz.model";

export function QuizColorsFormInput({
  form,
}: {
  form: UseFormReturnType<Omit<Quiz, "id">>;
}) {
  return (
    <>
      <Box>
        <Title order={4}>Sign up Form</Title>
        <ColorsFormInput
          form={form}
          fields={[
            ["buttonBackground", "Button Background"],
            ["buttonBorder", "Button Border"],
            ["buttonText", "Button Text"],
            ["labels", "Labels"],
          ]}
        />
      </Box>
      <br />
      <Divider my="sm" />
      <Box>
        <Title order={4}>Quiz</Title>
        <ColorsFormInput
          form={form}
          fields={[
            ["background", "QR Code Background"],
            ["questionText", "Question text"],
            ["choiceText", "Choice text"],
            ["choiceBackground", "Response text"],
            ["choiceNumber", "Choice Number"],
          ]}
        />
      </Box>
    </>
  );
}
